export class Relationship {
name: string;
type: string;
class: string;
arguments: string[] = [];
}